import React from 'react';
import { testimonials } from '../mock';
import { Star, Quote } from 'lucide-react';

const STAR_KEYS = ['s1', 's2', 's3', 's4', 's5'];

export default function Testimonials() {
  return (
    <section id="praise" className="relative py-24 md:py-32">
      <div className="absolute inset-0 grid-bg opacity-20" />
      <div className="relative max-w-[1440px] mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-3 font-mono text-[11px] tracking-[0.3em] text-violet-300/70 uppercase mb-5">
            <span className="h-px w-10 bg-violet-400/50" />
            <span>What People Say</span>
            <span className="h-px w-10 bg-violet-400/50" />
          </div>
          <h2 className="font-display text-6xl md:text-7xl lg:text-8xl leading-[0.9]">
            <span className="text-white">Mumbai </span>
            <span className="text-gradient-purple italic">APPROVED</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-4">
          {testimonials.map((t) => (
            <div key={t.name} className="relative p-6 md:p-8 rounded-md border border-violet-500/15 bg-gradient-to-b from-violet-950/25 to-transparent card-glow">
              <Quote className="absolute top-6 left-6 w-8 h-8 text-violet-400/25" />
              <div className="pl-10 mb-5">
                <div className="flex gap-0.5 text-amber-400">
                  {STAR_KEYS.map((sid) => (
                    <Star key={sid} size={14} fill="currentColor" />
                  ))}
                </div>
              </div>
              <p className="text-white/70 text-[15px] leading-relaxed italic mb-8">
                {t.text}
              </p>
              <div className="flex items-center gap-3 pt-5 border-t border-violet-500/10">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-violet-400 to-fuchsia-500 flex items-center justify-center font-mono text-xs tracking-wider text-white">
                  {t.initials}
                </div>
                <div>
                  <div className="font-medium text-white text-sm">{t.name}</div>
                  <div className="font-mono text-[10px] tracking-[0.2em] text-violet-300/50 uppercase">{t.meta}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
